<template>
  <div id="navBar">
    <div class="left">
      <slot name="leftSpan"><span>ToDoList</span></slot>
    </div>
    <div class="center">
      <slot name="center"><input class="search" type="text" placeholder="添加todo" id=""></slot>
    </div>
    <div class="right" id="specialEmoji">
      <span>{{dateEmoji}}</span>
      <slot name="rightSpan"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NavBar",
    data() {
      return {
        dateEmoji: ''
      }
    },
    created() {
      let hourNow = new Date().getHours()
      if(hourNow > 6 && hourNow < 16) {
        this.dateEmoji = '🌞元气满满'
      } else if (hourNow >= 16 && hourNow < 22) {
        this.dateEmoji = "💦加油鸭"
      } else {
        this.dateEmoji = '🌕早点休息啦'
      }
    }
  }
</script>

<style lang="less" scoped>
  #navBar {

    height: 6vh;
    width: 8.125rem - 2 * 0.3125rem;
    
    border-radius: 0.28125rem;
    background: @main-bgc;
    box-shadow: @box-shadow;

    position: absolute;
    left: 3.1rem;
    top: 5.6%;

    display: flex;
    padding: 0 0.3125rem;

    .center, .left, .right {
      text-align: center;
      height: 6vh;
      line-height: 6vh;
    }
    #specialEmoji {
      span {
        font-size: 0.1375rem;        
      }

    }
    .center {
      flex: 3;
    }

    .left, .right {
      flex: 1;
      font-family: 'PSYCHO';
      span {
        font-size: 0.2rem;
        display: inline-block;
        margin-top: 0.04rem;
        font-weight: 600;
      }
    }
  }


  .search {
    width: 100%;
    height: 0.2rem;

    border-style: none;
    
    border-radius: 0.125rem;
    background-color: @item-bgc;
    box-shadow:@itemBoxShadow;

    box-sizing: border-box;
    text-indent: 0.0625rem;

    outline: none;
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    // display: inline-block;
    // vertical-align: middle;
  }
</style>